import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Router} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {User} from '../models/user';
import {map} from 'rxjs/operators';
import * as JWT from 'jwt-decode';
import {Authority} from '../models/authority';


@Injectable()
export class AuthenticationService {

  constructor(private http: HttpClient, private router: Router) { }

  login(username: string, password: string) {
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tokenExp');
    localStorage.removeItem('ip');
    return this.http.post<any>('/gsb/auth/signin',
      { username, password })
      .pipe(
        map(token => {
          // login successful if there's a jwt token in the response
          console.log(token);
          // use JWT() for decode. Not jwt-decode() !!
          let t : any;
          t = JWT(token.accessToken);
          localStorage.setItem('token', token.accessToken);
          localStorage.setItem('tokenExp', t.exp);
          localStorage.setItem('ip', token.ip);
          localStorage.setItem('currentUser', JSON.stringify(t.currentUser));
          return t;
        })
      );
  }

  logout() {
      // remove user from local storage to log user out
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('tokenExp');
      localStorage.removeItem('ip');
      this.router.navigate(['/login']);
  }

  hasPermission(authArr: string[]) {
    let currentUser : User = JSON.parse(localStorage.getItem('currentUser'));

    for(let i = 0; i < currentUser.authorities.length; i++) {
      for (let j in authArr) {
        if (currentUser.authorities[i].name === authArr[j] || authArr[j] === '*') {
          return true;
        }
      }
    }
    return false;
  }

  permissionCount() {
    const currentUser : User = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.authorities && currentUser.authorities.length ) {
      return currentUser.authorities.length;
    } else {
      return 0;
    }
  }

}
